import { Redis } from '@upstash/redis'
import * as Sentry from '@sentry/nextjs'

// Hardcoded values for Redis connection
// This is a temporary solution until environment variable issues in Next.js are resolved
const REDIS_URL = 'https://frank-monkey-13821.upstash.io'
const REDIS_TOKEN = 'ATX9AAIjcDFmZTlhYjlkMzIzMTU0MjNkYjNmNmEwNDMyODhlOGRkZnAxMA'

// Initialize Redis client
export const redis = (() => {
  // Log environment variable availability for debugging
  // console.log('Redis environment check:', {
  //   NODE_ENV: process.env.NODE_ENV,
  //   usingHardcodedValues: true,
  // })

  // Create the Redis client with better retry settings
  try {
    return new Redis({
      url: REDIS_URL,
      token: REDIS_TOKEN,
      automaticDeserialization: true,
      retry: {
        // Increase retries and backoff for better handling of network issues
        retries: 5,
        backoff: (retryCount) => Math.min(Math.exp(retryCount) * 100, 2000),
      },
    })
  } catch (error) {
    console.error('Failed to initialize Redis client:', error)
    Sentry.captureException(error, {
      extra: { context: 'redis_initialization' },
    })
    throw error
  }
})()
